console.log(
  'Shopify Customer ID:',
  window.archiveCustomerId
);
	
(async function() {

const archiveProfileStorageKey = 'twaArchiveProfile.v1';
const archiveApiBase =
  '/apps/archive';
const archiveProfileOpenedFromRewards =
  new URLSearchParams(window.location.search).get('returnTo') === 'rewards';

let masterDistilleries = [];
let selectedDistilleries = {
  maltOperating: [],
  maltClosed: [],
  grainOperating: [],
  grainClosed: []
};

const distillerySummaryCategories = [
  {
    key: 'maltOperating',
    label: 'Single Malt Operating',
    icon: 'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/scotch-whisky-pot-still-copper.svg?v=1787261750'
  },
  {
    key: 'maltClosed',
    label: 'Single Malt Closed',
    icon: 'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/scotch-whisky-pot-still-steel.svg?v=1787261750'
  },
  {
    key: 'grainOperating',
    label: 'Grain Operating',
    icon: 'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/scotch-whisky-column-still-copper.svg?v=1787261750'
  },
  {
    key: 'grainClosed',
    label: 'Grain Closed',
    icon: 'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/scotch-whisky-column-still-steel.svg?v=1787261750'
  }
];

const distillerySummaryInlineLimit = 3;

let hasCloudProfile = false;
let profileCloudLoadFailed = false;
let profileCloudHadExistingProfile = false;
let archiveOwnershipResolution = {
  decision: 'fresh',
  profile: {},
  watchlist: []
};
let profileAccountState =
  window.archiveCustomerId ? 'unsaved' : 'guest';
let lastSavedProfileSnapshot = null;
let activeDistilleryType = 'Malt';
let activeDistilleryStatus = 'Operating';

document
  .querySelectorAll(
    '.archive-persona-pill'
  )
  .forEach(button => {

    button.addEventListener(
      'click',
      function () {

        selectPersona(
          this.dataset.persona,
          true
        );

      }
    );

  });

function getCurrentDistilleryKey() {

  return (
    activeDistilleryType.toLowerCase() +
    activeDistilleryStatus
  );

}

console.log(
  'Current key:',
  getCurrentDistilleryKey()
);

let representedDistilleries = new Set();

const iconUrls = {
  collector: 'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/Collector.svg?v=1780396102',
  historian: 'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/Historian.svg?v=1780396102',
  explorer: 'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/Explorer.svg?v=1780396102',
  investor: 'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/Investor.svg?v=1780396102',
  hunter: 'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/Hunter.svg?v=1780396102',
  drinker: 'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/Drinker.svg?v=1780396102'
};

function getStoredArchiveProfile() {

  return JSON.parse(
    localStorage.getItem(
      archiveProfileStorageKey
    ) || '{}'
  );

}

function setStoredArchiveProfile(
  archiveProfile
) {

  localStorage.setItem(
    archiveProfileStorageKey,
    JSON.stringify(
      archiveProfile
    )
  );

  if (!window.archiveCustomerId) {
    window.ArchiveOwnership?.captureAnonymousProfile(archiveProfile);
  }

}

async function loadProfileFromCloud(
  customerId
) {
  try {

    const response =
      await fetch(
        `${archiveApiBase}/profile/load?customerId=${customerId}`
      );

    if (!response.ok) {
      return { ok: false, profile: null };
    }

    const result =
      await response.json();

    return {
      ok: true,
      profile: result.profile || null,
      profileImageUrl: result.profileImageUrl || null,
      birthdayState: result.birthdayState || null
    };

  } catch (error) {

    console.error(
      'Unable to load Archive Profile',
      error
    );

    return { ok: false, profile: null };

  }
}

async function saveProfileToCloud(
  customerId,
  profile
) {
  try {

    const response =
      await fetch(
        `${archiveApiBase}/profile/save`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            customerId,
            operation: 'Persona',
            profile
          })
        });

    if (!response.ok) {

      console.error(
        'Unable to save Archive Profile'
      );

      return false;

    }

    const result = await response.json();
    return result && typeof result.profile === 'object'
      ? result.profile
      : null;

  } catch (error) {

    console.error(
      'Unable to save Archive Profile',
      error
    );

    return false;

  }
}

function selectPersona(
  selectedPersonaKey,
  saveToLocalStorage = true
) {

  personaKey =
    selectedPersonaKey;

  const persona =
    personas[personaKey] || personas.collector;

  document
    .querySelectorAll(
      '.archive-persona-pill'
    )
    .forEach(button => {
      button.classList.remove(
        'active'
      );
      button.setAttribute(
        'aria-pressed',
        'false'
      );
    });

  const selectedPersonaButton =
    document.querySelector(
      `.archive-persona-pill[data-persona="${personaKey}"]`
    );

  selectedPersonaButton
    ?.classList.add(
      'active'
    );

  selectedPersonaButton
    ?.setAttribute(
      'aria-pressed',
      'true'
    );

  const iconContainer =
    document.querySelector(
      '.archive-persona-icon'
    );

  if (iconContainer) {

    iconContainer.classList.remove(
      'collector',
      'historian',
      'explorer',
      'investor',
      'hunter',
      'drinker'
    );

    iconContainer.classList.add(
      personaKey
    );

  }

  const iconImage =
    document.getElementById(
      'personaIconImage'
    );

  if (iconImage) {

    iconImage.src =
      iconUrls[personaKey] || iconUrls.collector;

    iconImage.alt =
      persona.title;

  }
  
  const headerLoading =
  document.querySelector(
    '.archive-header-loading-indicator'
  );

	if (headerLoading) {
	  headerLoading.style.display = 'none';
	}

	if (iconContainer) {
	  iconContainer.style.display = 'flex';
	}

	document.getElementById(
	  'personaTitle'
	).style.display = 'block';

	document
	  .getElementById('personaHeader')
	  ?.classList.remove(
		'archive-persona-header-loading'
	  );

  document.getElementById(
    'personaTitle'
  ).textContent = persona.title;

  document.getElementById(
    'personaQuote'
  ).textContent = persona.quote;

  document.getElementById(
    'personaDescription'
  ).textContent = persona.description;

  renderFeaturedProducts(
    persona
  );

  if (saveToLocalStorage) {

    const archiveProfile =
      getStoredArchiveProfile();

    archiveProfile.currentPersona =
      personaKey;

    archiveProfile.archiveProfile =
      archiveProfile.archiveProfile || {};

    archiveProfile.archiveProfile.persona =
      personaKey;

    setStoredArchiveProfile(
      archiveProfile
    );

    window.ArchiveOwnership?.markPersonaInteraction(archiveProfile);

    syncProfileDirtyState();

  }

}

  const personas = {

  drinker: {
    title: "The Drinker",
    quote: "Whisky's final destination is the glass.",
    description:
      "You appreciate great bottles, but ultimately they exist to be enjoyed. For you, whisky is about flavour, conversation and memorable moments shared with others.",
    featuredProducts: [
      'hazelburn-2008-15-year-old-oloroso-cask-matured-springbank',
      'springbank-18-year-old-2024-release-springbank',
      'kilkerran-16-year-old-springbank',
      'longrow-100-proof-batch-no-1-pinot-noir-cask-matured-springbank'
    ],
	collectionName: 'Drinker',
    collectionUrl: '/collections/persona-drinker'
  },

  collector: {
    title: "The Collector",
    quote: "The pursuit is often as rewarding as the acquisition.",
    description:
      "You are drawn to bottles that stand apart. Limited releases, exceptional vintages and acquisitions that may only surface once before disappearing again.",
    featuredProducts: [
      'macallan-1977-hunter-hamilton-single-cask-hh6260',
      'springbank-23-year-old-2001-private-cask-no-146',
      'rosebank-1992-21-year-old-special-release-2014-rosebank',
      'hillside-1969-25-year-old-rare-malts-selection-rare-malts'
    ],
	collectionName: 'Collector',
    collectionUrl: '/collections/persona-collector'
  },

  explorer: {
    title: "The Explorer",
    quote: "The most interesting bottles are rarely the obvious ones.",
    description:
      "Independent bottlers. Unusual casks. Unexpected distilleries. The thrill comes not from following the crowd, but from discovering what others have overlooked.",
    featuredProducts: [
      'ben-nevis-1996-27-year-old-whisky-sponge-edition-58b-decadent-drinks',
      'ledaig-1995-29-year-old-westie-sponge-edition-no-4-decadent-drinks',
      'old-rhosdhu-1993-29-year-old-whisky-sponge-edition-no-67-decadent-drinks',
      'balmenach-2002-15-year-old-refill-barrel-thompson-bros'
    ],
	collectionName: 'Explorer',
    collectionUrl: '/collections/persona-explorer'
  },

  historian: {
    title: "The Historian",
    quote: "Every bottle preserves a moment in whisky history.",
    description:
      "You are drawn not only to what is in the glass, but to the stories behind it. Lost distilleries, forgotten releases and whiskies that can never be recreated.",
    featuredProducts: [
      'hillside-1969-25-year-old-rare-malts-selection-rare-malts',
      'rosebank-1992-21-year-old-special-release-2014-rosebank',
      'garnheath-1974-44-year-old-xop-dl12779-douglas-laing',
      'glenlivet-1973-single-cask-natural-cask-strength-2000-scott-s-selection'
    ],
	collectionName: 'Historian',
    collectionUrl: '/collections/persona-historian'
  },

  investor: {
    title: "The Investor",
    quote: "Scarcity tells part of the story. Provenance tells the rest.",
    description:
      "You seek bottles with strong provenance, limited availability and lasting significance. Some whiskies become more than whisky.",
    featuredProducts: [
      'macallan-1977-hunter-hamilton-single-cask-hh6260',
      'springbank-23-year-old-2001-private-cask-no-146',
      'rosebank-1992-21-year-old-special-release-2014-rosebank',
      'ben-nevis-1996-27-year-old-whisky-sponge-edition-58b-decadent-drinks'
    ],
	collectionName: 'Investor',
    collectionUrl: '/collections/persona-investor'
  },

  hunter: {
    title: "The Hunter",
    quote: "Great whisky isn't always the most expensive whisky.",
    description:
      "You enjoy uncovering exceptional bottles that deliver far beyond their asking price. Finding the hidden gem is every bit as satisfying as acquiring it.",
    featuredProducts: [
      'bunnahabhain-1979-25-year-old-single-cask-7405-lombard-jewels-of-scotland',
      'linkwood-1988-18-year-old-douglas-laing-old-malt-cask-single-cask-2111',
      'glenallachie-1996-21-year-old-cask-strength-collection-signatory-vintage',
      'craigellachie-19-year-old-special-reserve-craigellachie'
    ],
	collectionName: 'Hunter',
    collectionUrl: '/collections/persona-hunter'
  }

};


  const params =
  new URLSearchParams(
    window.location.search
  );

let personaKey =
  (
    params.get('persona') ||
    'collector'
  ).toLowerCase();
  
  representedDistilleries = new Set(
	window.archiveRepresentedDistilleries || []
	);

  ensureGlobalClearActions();
  enhanceProfilePreservationCard();
  syncProfileRowClearActions();
  syncGlobalClearActions();

  window.addEventListener(
    'archive:watchlist-changed',
    syncProfileDirtyState
  );
  
  if (window.archiveOwnershipReady || window.ArchiveOwnership) {
    archiveOwnershipResolution = await (
      window.archiveOwnershipReady || window.ArchiveOwnership.ready
    );
  }

  await initializeArchiveProfile();
  
  selectPersona(
	  personaKey,
	  false
	);

  await initializeDistilleryData();

async function initializeArchiveProfile() {

  const customerId =
    params.get('uid');

  const personaFromUrl =
    params.get('persona')?.toLowerCase();

  const signedInCustomerId =
    window.archiveCustomerId;

  let archiveProfile = signedInCustomerId
    ? JSON.parse(JSON.stringify(
        archiveOwnershipResolution.decision === 'keep'
          ? archiveOwnershipResolution.profile || {}
          : {}
      ))
    : getStoredArchiveProfile();

  if (signedInCustomerId) {

    const cloudResult =
      await loadProfileFromCloud(
        signedInCustomerId
      );

    if (!cloudResult.ok) {
      profileCloudLoadFailed = true;
    }

    const cloudProfile = cloudResult.profile;

    if (cloudResult.ok && cloudProfile) {

	  archiveProfile =
		cloudProfile;

	  hasCloudProfile = true;
	  profileCloudHadExistingProfile = true;

	  setStoredArchiveProfile(
		archiveProfile
	  );

	  setLastSavedProfileBaseline(cloudProfile);

	  console.log(
		'Archive profile loaded from Shopify'
	  );

	}

    window.ArchiveOwnership?.completeProfileHydration({
      ok: cloudResult.ok,
      hasCloudProfile: profileCloudHadExistingProfile
    });

    // Member profile photo in the Persona header (archive-persona-portrait.js).
    window.ArchivePersonaPortrait?.connect({
      apiBase: archiveApiBase,
      showToast: showArchiveToast
    });
    window.ArchivePersonaPortrait?.setImage(
      cloudResult.profileImageUrl || null
    );

    // Member birthday under the photo (archive-persona-birthday.js). Shown only when the
    // profile loaded: the server's birthdayState decides Valid / Missing / Invalid.
    if (cloudResult.ok) {
      window.ArchivePersonaBirthday?.mount({
        apiBase: archiveApiBase,
        customerId: signedInCustomerId,
        profile: cloudProfile || {},
        birthdayState: cloudResult.birthdayState,
        showToast: showArchiveToast
      });
    }

  }

  if (customerId) {

    archiveProfile.customerId =
      customerId;

  }

  if (
    personaFromUrl &&
    !archiveProfile.originalPersona
  ) {

    archiveProfile.originalPersona =
      personaFromUrl;

  }

  archiveProfile.archiveProfile =
    archiveProfile.archiveProfile || {};

  const storedPersona =
    archiveProfile.archiveProfile.persona ||
    archiveProfile.currentPersona;

  if (hasCloudProfile) {

	  personaKey =
		storedPersona ||
		'collector';

	} else {

	  personaKey =
		personaFromUrl ||
		storedPersona ||
		'collector';

	}

  archiveProfile.currentPersona =
    personaKey;

  archiveProfile.archiveProfile.persona =
    personaKey;

  setStoredArchiveProfile(
    archiveProfile
  );

}

async function initializeDistilleryData() {

  try {

    const response =
      await fetch(
        'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/archive-distilleries.json?v=1780789384'
      );

    const data =
      await response.json();

    masterDistilleries = data;

    loadArchiveProfile();

  } catch (error) {

    console.error(
      'Unable to load distilleries',
      error
    );

  }

}

async function renderFeaturedProducts(persona) {

  const container =
    document.getElementById('personaRecommendations');
	
	container.innerHTML = `
  <div class="archive-loading-indicator">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
`;
	
	console.log(
	  'Loading featured products:',
	  persona.featuredProducts
	);

  const products = await Promise.all(
    persona.featuredProducts.map(async handle => {

      try {

        const response =
		  await fetch(`/products/${encodeURIComponent(handle)}?view=archive-card-data`);

		if (!response.ok) {
		  return null;
		}

		return await response.json();

      } catch {
        return null;
      }

    })
  );
  
  container.innerHTML = products
    .filter(Boolean)
    .map((product, index) => {

      const image =
        product.featured_image || '';

      const productUrl = `/products/${product.handle}`;
      const cardId = `archive-persona-product-${product.id}-${index}`;
      const quickAddDisplay = product.quick_add_enabled ? 'flex' : 'none';
      const mobileQuickAddDisplay = product.quick_add_enabled && product.mobile_quick_add_enabled ? 'flex' : 'none';

      return `
        <product-card
          id="${cardId}"
          class="archive-product-card"
          data-product-id="${product.id}"
          style="--quick-add-display:${quickAddDisplay};--quick-add-mobile-display:${mobileQuickAddDisplay};--quick-add-mobile-opacity:${mobileQuickAddDisplay === 'flex' ? '1' : '0'}"
        >
          <div class="archive-watchlist-media">
          <a href="${productUrl}" class="archive-product-image" ref="productCardLink">
              <img
                src="${image}"
                alt="${product.title}"
                loading="lazy">
              ${window.ArchiveCommunityRating?.markup(
                product.whiskybase_score,
                product.community_reference_enabled,
                'compact'
              ) || ''}
          </a>

            ${product.watchlist_markup || ''}
          </div>

          <a href="${productUrl}" class="archive-product-title">
            ${product.title}
          </a>

          <div class="archive-product-price">${product.price}</div>

          <div class="archive-persona-quick-add" aria-label="Quick Add for ${product.title}">
            ${product.quick_add_markup || ''}
          </div>
        </product-card>
      `;

    })
    .join('');

  container.insertAdjacentHTML(
    'beforeend',
    `
      <div class="archive-view-all">
        <a
          href="${persona.collectionUrl}"
          class="archive-concierge-link">
          Explore All ${persona.collectionName} Expressions →
        </a>
      </div>
    `
  );
}

function saveArchiveProfile() {

  const archiveProfile =
    getStoredArchiveProfile();

  const profile =
    archiveProfile.archiveProfile || {};

  document
    .querySelectorAll(
      '.archive-profile-group'
    )
    .forEach(group => {

      const category =
        group.dataset.category;

      profile[category] =
        Array.from(
          group.querySelectorAll(
            '.archive-chip.active'
          )
        ).map(chip =>
          chip.textContent.trim()
        );

    });

  profile.persona =
    personaKey;

  profile.distilleries =
    selectedDistilleries;

  archiveProfile.currentPersona =
    personaKey;

  archiveProfile.archiveProfile =
    profile;

  setStoredArchiveProfile(
    archiveProfile
  );

  syncProfileDirtyState();

}

function syncProfileRowClearActions() {
  document
    .querySelectorAll(
      '.archive-profile-group'
    )
    .forEach(group => {
      let clear =
        group.querySelector(
          '.archive-profile-row-clear'
        );

      if (!clear) {
        clear =
          document.createElement('button');
        clear.type = 'button';
        clear.className =
          'archive-profile-row-clear';
        clear.textContent = 'Clear';
        clear.setAttribute(
          'aria-label',
          `Clear ${
            group.querySelector(
              '.archive-profile-label'
            )?.textContent.trim() ||
            'profile row'
          }`
        );
        group.querySelector(
          '.archive-profile-label'
        )?.after(clear);
      }

      const hasSelection =
        Boolean(group.querySelector('.archive-chip.active'));
      clear.hidden = false;
      clear.disabled = !hasSelection;
      clear.setAttribute(
        'aria-disabled',
        String(!hasSelection)
      );
    });

  syncGlobalClearActions();
}

function ensureGlobalClearActions() {
  const profile =
    document.querySelector('.archive-profile');
  const profileHeading =
    profile?.querySelector(
      ':scope > .archive-persona-sction-title'
    );

  if (
    profileHeading &&
    !profile.querySelector(
      '.archive-profile-clear-all'
    )
  ) {
    const button =
      document.createElement('button');
    button.type = 'button';
    button.className =
      'archive-global-clear archive-profile-clear-all';
    button.textContent = 'Clear all';
    profileHeading.after(button);
  }

  const distilleries =
    document.querySelector(
      '.archive-distilleries'
    );

  if (
    distilleries &&
    !distilleries.querySelector(
      '.archive-distilleries-clear-all'
    )
  ) {
    const button =
      document.createElement('button');
    button.type = 'button';
    button.className =
      'archive-global-clear archive-distilleries-clear-all';
    button.textContent = 'Clear all';
    distilleries.querySelector(
      ':scope > .archive-profile-label'
    )?.after(button);
  }

  if (!document.getElementById(
    'archiveClearDialog'
  )) {
    const dialog =
      document.createElement('dialog');
    dialog.id = 'archiveClearDialog';
    dialog.className = 'archive-clear-dialog';
    dialog.innerHTML = `
      <form method="dialog">
        <button
          type="button"
          class="archive-popover-close archive-clear-dialog__close"
          aria-label="Close">×</button>
        <h3 id="archiveClearDialogTitle"></h3>
        <p id="archiveClearDialogCopy"></p>
        <div class="archive-clear-dialog__actions">
          <button value="cancel">Cancel</button>
          <button
            type="button"
            class="archive-clear-dialog__confirm">
          </button>
        </div>
      </form>
    `;
    dialog.setAttribute(
      'aria-labelledby',
      'archiveClearDialogTitle'
    );
    dialog.setAttribute(
      'aria-describedby',
      'archiveClearDialogCopy'
    );
    document.body.append(dialog);

    dialog.addEventListener(
      'click',
      function(event) {
        if (event.target === this) {
          this.close('cancel');
        }
      }
    );

    dialog.querySelector(
      '.archive-clear-dialog__close'
    ).addEventListener(
      'click',
      function() {
        dialog.querySelector(
          'button[value="cancel"]'
        )?.click();
      }
    );

    dialog.querySelector(
      '.archive-clear-dialog__confirm'
    ).addEventListener(
      'click',
      function() {
        if (dialog.dataset.mode === 'profile') {
          document
            .querySelectorAll(
              '.archive-profile-group .archive-chip.active'
            )
            .forEach(chip =>
              chip.classList.remove('active')
            );
          syncProfileRowClearActions();
          saveArchiveProfile();
        }

        if (dialog.dataset.mode === 'distilleries') {
          distillerySummaryCategories
            .forEach(category => {
              selectedDistilleries[
                category.key
              ] = [];
            });
          renderSelectedDistilleryTags();
          saveArchiveProfile();

          const search =
            document.getElementById(
              'archiveDistillerySearch'
            );
          if (search) {
            renderDistillerySuggestions(
              search.value
            );
          }
        }

        syncGlobalClearActions();
        dialog.close('confirmed');
      }
    );
  }
}

function syncGlobalClearActions() {
  const profileClear =
    document.querySelector(
      '.archive-profile-clear-all'
    );
  const distilleryClear =
    document.querySelector(
      '.archive-distilleries-clear-all'
    );

  if (profileClear) {
    const hasProfileSelections =
      Boolean(document.querySelector(
        '.archive-profile-group .archive-chip.active'
      ));
    profileClear.hidden = false;
    profileClear.disabled = !hasProfileSelections;
    profileClear.setAttribute(
      'aria-disabled',
      String(!hasProfileSelections)
    );
  }

  if (distilleryClear) {
    const hasDistilleries =
      distillerySummaryCategories.some(
        category =>
          (
            selectedDistilleries[
              category.key
            ] || []
          ).length
      );
    distilleryClear.hidden = false;
    distilleryClear.disabled = !hasDistilleries;
    distilleryClear.setAttribute(
      'aria-disabled',
      String(!hasDistilleries)
    );
  }
}

function openArchiveClearDialog(mode) {
  const dialog =
    document.getElementById(
      'archiveClearDialog'
    );

  if (!dialog) {
    return;
  }

  const profileMode = mode === 'profile';
  dialog.dataset.mode = mode;
  dialog.querySelector('h3').textContent =
    profileMode
      ? 'Clear all profile preferences?'
      : 'Clear all selected distilleries?';
  dialog.querySelector('p').textContent =
    profileMode
      ? 'This will remove your selected profile preferences. Your Archive Persona and selected distilleries will not be changed.'
      : 'This will remove all distilleries currently selected in your Archive Profile.';
  dialog.querySelector(
    '.archive-clear-dialog__confirm'
  ).textContent =
    profileMode
      ? 'Clear preferences'
      : 'Clear distilleries';
  dialog.showModal();
}

function loadArchiveProfile() {

  const saved =
    localStorage.getItem(
      archiveProfileStorageKey
    );

  if (!saved) {
    return;
  }

  const archiveProfile =
    JSON.parse(saved);

  const profile =
    archiveProfile.archiveProfile || {};
	
	if (profile.persona) {

  personaKey =
    profile.persona;

  selectPersona(
    personaKey,
    false
  );

}

  document
    .querySelectorAll(
      '.archive-profile-group'
    )
    .forEach(group => {

      const category =
        group.dataset.category;

      const values =
        profile[category] || [];

      group
        .querySelectorAll(
          '.archive-chip'
        )
        .forEach(chip => {

          if (
            values.includes(
              chip.textContent.trim()
            )
          ) {
            chip.classList.add(
              'active'
            );
          }

        });

    });

  syncProfileRowClearActions();
  syncGlobalClearActions();

	selectedDistilleries =
	  profile.distilleries || {
		maltOperating: [],
		maltClosed: [],
		grainOperating: [],
		grainClosed: []
	  };

	if (masterDistilleries.length) {

	  renderDistillerySections();

	}

}

function renderDistillerySections() {

  const container =
    document.getElementById(
      'archiveDistilleryContainer'
    );

  if (!container || !masterDistilleries.length) {
    return;
  }

  container.innerHTML = `

    <div class="archive-distillery-search-wrapper">

      <input
        id="archiveDistillerySearch"
        type="text"
        autocomplete="off"
        class="archive-distillery-search"
        placeholder="Search ${activeDistilleryType.toLowerCase()} distilleries..." />

      <div
        id="archiveDistillerySuggestions"
        class="archive-distillery-suggestions">
      </div>

    </div>

  `;

  const search =
    document.getElementById(
      'archiveDistillerySearch'
    );

  search.addEventListener(
    'input',
    function() {

      renderDistillerySuggestions(
        this.value.trim()
      );

    }
  );

  renderSelectedDistilleryTags();

}

function renderDistillerySuggestions(searchTerm) {

  const container =
    document.getElementById(
      'archiveDistillerySuggestions'
    );

  if (!container) {
    return;
  }

  searchTerm =
    (searchTerm || '').trim();

  if (!searchTerm) {

    container.innerHTML = '';

    return;
  }

  const filtered =
    masterDistilleries
      .filter(x =>
        x.type === activeDistilleryType &&
        x.status === activeDistilleryStatus
      )
      .filter(x =>
        !(
          selectedDistilleries[
            getCurrentDistilleryKey()
          ] || []
        ).includes(
          x.distillery
        )
      )
      .filter(x =>
        x.distillery
          .toLowerCase()
          .includes(
            searchTerm.toLowerCase()
          )
      )
      .slice(0, 25);

  container.innerHTML =
    filtered
      .map(item => {

        const represented =
          representedDistilleries.has(
            item.distillery
          );

        return `
          <div
            class="archive-distillery-option"
            data-distillery="${item.distillery}">

            <span class="archive-distillery-name">

              ${
                represented
                  ? '<span class="archive-gold-dot"></span>'
                  : ''
              }

              ${item.distillery}

            </span>

            <span class="archive-distillery-region">
              ${item.region || ''}
            </span>

          </div>
        `;

      })
      .join('');

}

function enhanceProfilePreservationCard() {
  const notice =
    document.querySelector('.archive-profile-notice');

  if (!notice || notice.classList.contains('archive-profile-notice--enhanced')) {
    return;
  }

  const saveButton =
    notice.querySelector('#archiveSaveCustomerProfile');
  const rewardsLink =
    notice.querySelector('#archiveBackToRewards');
  const guestLink =
    notice.querySelector('.archive-save-profile-link:not(#archiveBackToRewards)');
  const toast =
    notice.querySelector('#archiveProfileToast');
  const actions =
    notice.querySelector('.archive-profile-actions') ||
    document.createElement('div');

  actions.classList.add('archive-profile-actions');

  if (guestLink && !actions.contains(guestLink)) {
    actions.appendChild(guestLink);
  }

  const status = document.createElement('div');
  status.className = 'archive-profile-notice__status';
  status.innerHTML = `
    <span class="archive-profile-notice__icon" aria-hidden="true"></span>
    <div>
      <h3 data-archive-profile-status-title></h3>
      <p data-archive-profile-status-copy></p>
    </div>
  `;

  const preserve = document.createElement('div');
  preserve.className = 'archive-profile-notice__preserve';

  const eyebrow = document.createElement('p');
  eyebrow.className = 'archive-profile-notice__eyebrow';
  eyebrow.textContent = 'Preserve Your Archive Profile';

  const explanation = document.createElement('p');
  explanation.className = 'archive-profile-notice__copy';
  explanation.textContent = saveButton
    ? 'Save your Archive Profile to preserve your personal whisky preferences across future visits and devices.'
    : 'Create your Archive account to preserve your personal whisky profile across future visits and devices.';

  preserve.append(eyebrow, explanation, actions);
  notice.replaceChildren(status, preserve);
  notice.classList.add('archive-profile-notice--enhanced');
  syncProfileDirtyState();

  if (toast) {
    document.body.appendChild(toast);
  }

  if (rewardsLink) {
    rewardsLink.classList.add('archive-save-profile-button--secondary');
  }

  if (guestLink) {
    guestLink.addEventListener('click', event => {
      saveArchiveProfile();

      const intent = window.ArchiveOwnership
        ?.createProfilePreservationIntent(window.location.pathname);
      if (!intent) return;

      event.preventDefault();
      const authenticationUrl = new URL(guestLink.href, window.location.origin);
      const returnUrl = new URL(intent.returnPath, window.location.origin);
      returnUrl.searchParams.set('archiveHandoff', intent.nonce);
      authenticationUrl.searchParams.set(
        'return_to',
        `${returnUrl.pathname}${returnUrl.search}`
      );
      window.location.assign(authenticationUrl.href);
    });
  }
}

function updateProfilePreservationStatus(state) {
  profileAccountState = state;

  const notice = document.querySelector(
    '.archive-profile-notice'
  );
  if (notice) {
    notice.dataset.profileState = state;
  }

  const title = document.querySelector(
    '[data-archive-profile-status-title]'
  );
  const copy = document.querySelector(
    '[data-archive-profile-status-copy]'
  );

  if (!title || !copy) {
    return;
  }

  const content = {
    guest: {
      title: 'Your Archive Profile is taking shape',
      copy: 'Your preferences are currently saved in this browser and are helping us understand your whisky interests.'
    },
    unsaved: {
      title: 'Your profile has unsaved changes',
      copy: 'Your latest preferences are currently saved in this browser. Save them to update your Archive Profile.'
    },
    saved: {
      title: 'Your Archive Profile is saved',
      copy: 'Your preferences are preserved with your account across future visits and devices.'
    }
  }[state] || null;

  if (content) {
    title.textContent = content.title;
    copy.textContent = content.copy;
  }
}

function canonicalizeProfileValue(value) {
  if (Array.isArray(value)) {
    return value
      .map(canonicalizeProfileValue)
      .sort((left, right) =>
        JSON.stringify(left).localeCompare(JSON.stringify(right))
      );
  }

  if (value && typeof value === 'object') {
    return Object.keys(value)
      .sort()
      .reduce((result, key) => {
        result[key] = canonicalizeProfileValue(value[key]);
        return result;
      }, {});
  }

  return value;
}

function createProfileSnapshot(
  profileData,
  includeLiveWatchlist = false
) {
  const comparable = JSON.parse(
    JSON.stringify(profileData || {})
  );

  delete comparable.version;
  delete comparable.savedAt;

  const watchlistController = window.ArchiveWatchlist;
  if (
    includeLiveWatchlist &&
    watchlistController?.status === 'ready'
  ) {
    comparable.watchlist = watchlistController.getItems();
  }

  return JSON.stringify(
    canonicalizeProfileValue(comparable)
  );
}

function profileHasUnsavedChanges() {
  if (!window.archiveCustomerId) {
    return false;
  }

  if (lastSavedProfileSnapshot === null) {
    return true;
  }

  return createProfileSnapshot(
    getStoredArchiveProfile(),
    true
  ) !== lastSavedProfileSnapshot;
}

function syncProfileDirtyState() {
  if (!window.archiveCustomerId) {
    updateProfilePreservationStatus('guest');
    return;
  }

  if (profileCloudLoadFailed) {
    updateProfilePreservationStatus('unsaved');
    const failedButton = document.getElementById('archiveSaveCustomerProfile');
    if (failedButton) {
      failedButton.disabled = true;
      failedButton.setAttribute('aria-disabled', 'true');
    }
    return;
  }

  const dirty = profileHasUnsavedChanges();
  updateProfilePreservationStatus(
    dirty ? 'unsaved' : 'saved'
  );

  const button = document.getElementById(
    'archiveSaveCustomerProfile'
  );

  if (button && button.dataset.saving !== 'true') {
    button.disabled = !dirty;
    button.setAttribute(
      'aria-disabled',
      String(!dirty)
    );
  }
}

function setLastSavedProfileBaseline(profileData) {
  lastSavedProfileSnapshot = createProfileSnapshot(
    profileData,
    false
  );
  syncProfileDirtyState();
}

function hideArchiveToast(toast) {
  clearTimeout(toast._hideTimeout);
  clearTimeout(toast._hiddenTimeout);
  toast.classList.remove('visible');
  toast._hiddenTimeout = setTimeout(() => {
    toast.hidden = true;
  }, 220);
}

function showArchiveToast(
  message,
  isError = false
) {

  const toast =
    document.getElementById(
      'archiveProfileToast'
    );

  if (!toast) {
    return;
  }

  const options =
    typeof message === 'object'
      ? message
      : {
          type: isError ? 'error' : 'success',
          title: isError
            ? 'Profile Couldn’t Be Saved'
            : 'Archive Profile Saved',
          message
        };

  if (!toast.querySelector('.archive-profile-toast__close')) {
    toast.innerHTML = `
      <span class="archive-profile-toast__icon" aria-hidden="true"></span>
      <div class="archive-profile-toast__content">
        <p class="archive-profile-toast__title"></p>
        <p class="archive-profile-toast__message"></p>
      </div>
      <button type="button" class="archive-profile-toast__close" aria-label="Dismiss notification">×</button>
    `;
    toast.querySelector('.archive-profile-toast__close')
      .addEventListener('click', () => hideArchiveToast(toast));
  }

  const error = options.type === 'error';
  toast.querySelector('.archive-profile-toast__title').textContent =
    options.title;
  toast.querySelector('.archive-profile-toast__message').textContent =
    options.message;
  toast.classList.toggle('error', error);
  toast.setAttribute('role', error ? 'alert' : 'status');
  toast.setAttribute('aria-live', error ? 'assertive' : 'polite');
  toast.setAttribute('aria-atomic', 'true');
  toast.hidden = false;

  clearTimeout(toast._hideTimeout);
  clearTimeout(toast._hiddenTimeout);
  requestAnimationFrame(() => toast.classList.add('visible'));
  toast._hideTimeout = setTimeout(() => hideArchiveToast(toast), 4600);

}

function setArchiveSaveButtonLoading(button, isSaving) {
  if (isSaving) {
    button.dataset.defaultLabel =
      button.dataset.defaultLabel || button.textContent.trim();
    button.dataset.saving = 'true';
    button.style.minWidth = `${Math.ceil(button.getBoundingClientRect().width)}px`;
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    button.innerHTML = `
      <span class="archive-save-profile-button__spinner" aria-hidden="true"></span>
      <span>Saving Profile…</span>
    `;
    return;
  }

  button.disabled = false;
  button.removeAttribute('aria-disabled');
  button.removeAttribute('aria-busy');
  delete button.dataset.saving;
  button.textContent = button.dataset.defaultLabel || 'Save Archive Profile';
  button.style.minWidth = '';
  syncProfileDirtyState();
}

function showBackToRewardsButton() {

  if (!archiveProfileOpenedFromRewards) {
    return;
  }

  const button =
    document.getElementById(
      'archiveBackToRewards'
    );

  if (!button) {
    return;
  }

  button.hidden = false;

}

document.addEventListener(
  'click',
  event => {

    const button =
      event.target.closest(
        '#archiveBackToRewards'
      );

    if (!button || button.hidden) {
      return;
    }

    try {
      window.sessionStorage.setItem(
        'twaArchiveProfileCompletionReturn',
        '1'
      );
    } catch (error) {
      console.warn(
        'Unable to record Archive Profile completion return state.',
        error
      );
    }

  }
);

function positionSelectedMorePopover(details) {
  const trigger =
    details.querySelector('summary');
  const popover =
    details.querySelector(
      '.archive-selected-more__popover'
    );
  const list =
    details.querySelector(
      '.archive-selected-more__chips'
    );

  if (!trigger || !popover || !list) {
    return;
  }

  details.classList.remove(
    'archive-selected-more--up'
  );
  popover.style.maxHeight = 'none';
  popover.style.overflow = 'visible';
  list.style.maxHeight = '';

  const triggerRect =
    trigger.getBoundingClientRect();
  const desiredHeight =
    popover.offsetHeight;
  const viewportGap = 12;
  const anchorGap = 9;
  const availableBelow =
    Math.max(
      1,
      window.innerHeight -
        triggerRect.bottom -
        anchorGap -
        viewportGap
    );
  const availableAbove =
    Math.max(
      1,
      triggerRect.top -
        anchorGap -
        viewportGap
    );
  const openUp =
    desiredHeight > availableBelow &&
    (
      desiredHeight <= availableAbove ||
      availableAbove > availableBelow
    );
  const available =
    openUp
      ? availableAbove
      : availableBelow;

  details.classList.toggle(
    'archive-selected-more--up',
    openUp
  );

  if (desiredHeight > available) {
    const fixedHeight =
      popover.offsetHeight -
      list.offsetHeight;
    list.style.maxHeight =
      `${Math.max(
        1,
        Math.floor(
          available - fixedHeight
        )
      )}px`;
  }
}

function bindSelectedMorePopovers(container) {
  container
    .querySelectorAll(
      '.archive-selected-more'
    )
    .forEach(details => {
      details.addEventListener(
        'toggle',
        function() {
          if (!this.open) {
            return;
          }

          requestAnimationFrame(() =>
            positionSelectedMorePopover(this)
          );
        }
      );
    });
}

function closeSelectedInfoPopover(info, returnFocus = false) {
  if (!info) {
    return;
  }

  info.classList.remove('is-hovered', 'is-pinned');
  const button = info.querySelector(
    '.archive-selected-info__button'
  );
  button?.setAttribute('aria-expanded', 'false');

  if (returnFocus) {
    button?.focus();
  }
}

function bindSelectedInfoPopover(info) {
  if (
    !info ||
    !window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    ).matches
  ) {
    return;
  }

  info.addEventListener('mouseenter', function() {
    if (!this.classList.contains('is-pinned')) {
      this.classList.add('is-hovered');
    }
  });

  info.addEventListener('mouseleave', function() {
    if (!this.classList.contains('is-pinned')) {
      this.classList.remove('is-hovered');
    }
  });
}

window.addEventListener('resize', function() {
  document
    .querySelectorAll(
      '.archive-selected-more[open]'
    )
    .forEach(positionSelectedMorePopover);
});

function renderSelectedDistilleryTags() {
  const container =
    document.getElementById(
      'archiveSelectedDistilleries'
    );

  if (!container) {
    return;
  }
  
  const wrapper =
  document.querySelector(
    '.archive-selected-distilleries-wrapper'
  );

  if (!wrapper) {
    return;
  }

  const categories =
    distillerySummaryCategories
      .map(category => ({
        ...category,
        selections:
          selectedDistilleries[category.key] || []
      }))
      .filter(category =>
        category.selections.length
      );

  const total =
    categories.reduce(
      (sum, category) =>
        sum + category.selections.length,
      0
    );

  const renderTag = (name, key) => {
    const represented =
      representedDistilleries.has(name);

    return `
      <span class="archive-distillery-tag">
        ${name}
        ${
          represented
            ? '<span class="archive-gold-dot"></span>'
            : ''
        }
        <button
          type="button"
          class="archive-distillery-remove"
          data-name="${name}"
          data-key="${key}"
          aria-label="Remove ${name}">
          ×
        </button>
      </span>
    `;
  };

  wrapper.style.display = 'block';
  syncGlobalClearActions();

  wrapper.querySelector(
    '.archive-selected-heading'
  ).innerHTML = `
    <span>Selected distilleries · ${total}</span>
    <span class="archive-selected-info">
      <button
        type="button"
        class="archive-selected-info__button"
        aria-label="About selected distilleries"
        aria-expanded="false">
        i
      </button>
      <span
        class="archive-selected-info__popover"
        role="dialog"
        aria-label="About this section">
        <button
          type="button"
          class="archive-popover-close archive-selected-info__close"
          aria-label="Close">×</button>
        <strong>About this section</strong>
        <span>These are the distilleries you’ve chosen to include in your Archive Profile.</span>
        <span>They help us surface bottles and content tailored to your collecting interests.</span>
      </span>
    </span>
  `;

  bindSelectedInfoPopover(
    wrapper.querySelector('.archive-selected-info')
  );

  if (!categories.length) {
    container.innerHTML = `
      <p class="archive-selected-empty">
        No distilleries selected yet. Use the tabs above to explore and add distilleries.
      </p>
    `;
    return;
  }

  container.innerHTML =
    categories
      .map((category, index) => {
        const visible =
          category.selections.slice(
            0,
            distillerySummaryInlineLimit
          );
        const remaining =
          category.selections.slice(
            distillerySummaryInlineLimit
          );
        const edgeClass =
          index === 0
            ? ' archive-selected-category--first'
            : index === categories.length - 1
              ? ' archive-selected-category--last'
              : '';

        return `
          <div
            class="archive-selected-category${edgeClass}"
            role="group"
            aria-label="${category.label}">
            <div class="archive-selected-category__meta">
              <img src="${category.icon}" alt="" aria-hidden="true">
              <span aria-label="${category.selections.length} selected">· ${category.selections.length}</span>
            </div>
            <div class="archive-selected-category__chips">
              ${
                visible
                  .map(name =>
                    renderTag(name, category.key)
                  )
                  .join('')
              }
              ${
                remaining.length
                  ? `
                    <details class="archive-selected-more">
                      <summary>+${remaining.length} more</summary>
                      <div class="archive-selected-more__popover">
                        <button
                          type="button"
                          class="archive-popover-close archive-selected-more__close"
                          aria-label="Close">×</button>
                        <div class="archive-selected-more__heading">
                          <img src="${category.icon}" alt="" aria-hidden="true">
                          <span>· ${category.selections.length}</span>
                        </div>
                        <div class="archive-selected-more__chips">
                          ${
                            remaining
                              .map(name =>
                                renderTag(name, category.key)
                              )
                              .join('')
                          }
                        </div>
                        <button
                          type="button"
                          class="archive-selected-category-clear"
                          data-key="${category.key}">
                          Clear
                        </button>
                      </div>
                    </details>
                  `
                  : ''
              }
            </div>
          </div>
        `;
      })
      .join('');

  bindSelectedMorePopovers(container);

}

function renderDistilleryChips(distilleries) {

  return distilleries
    .map(distillery => {

      const selected =
        selectedDistilleries.includes(
          distillery.distillery
        );

      const represented =
        representedDistilleries.has(
          distillery.distillery
        );

      return `
        <button
          type="button"
          class="archive-chip archive-distillery-chip ${selected ? 'active' : ''}"
          data-distillery="${distillery.distillery}">

          ${
            represented
              ? '<span class="archive-gold-dot"></span>'
              : ''
          }

          ${distillery.distillery}

        </button>
      `;

    })
    .join('');

}

document.addEventListener('click', function(e) {

  document
    .querySelectorAll(
      '.archive-selected-more[open]'
    )
    .forEach(details => {
      if (!details.contains(e.target)) {
        details.removeAttribute('open');
      }
    });

  const info =
    document.querySelector(
      '.archive-selected-info.is-hovered, .archive-selected-info.is-pinned'
    );

  if (info && !info.contains(e.target)) {
    closeSelectedInfoPopover(info);
  }

  const moreClose =
    e.target.closest('.archive-selected-more__close');

  if (moreClose) {
    const details = moreClose.closest('.archive-selected-more');
    details?.removeAttribute('open');
    details?.querySelector('summary')?.focus();
    return;
  }

  const infoClose =
    e.target.closest('.archive-selected-info__close');

  if (infoClose) {
    closeSelectedInfoPopover(
      infoClose.closest('.archive-selected-info'),
      true
    );
    return;
  }

  const infoButton =
    e.target.closest(
      '.archive-selected-info__button'
    );

  if (infoButton) {
    const infoWrapper =
      infoButton.closest(
        '.archive-selected-info'
      );
    const wasPinned =
      infoWrapper.classList.contains('is-pinned');
    infoWrapper.classList.remove('is-hovered');
    infoWrapper.classList.toggle('is-pinned', !wasPinned);

    infoButton.setAttribute(
      'aria-expanded',
      String(!wasPinned)
    );
    return;
  }

  const profileClearAll =
    e.target.closest(
      '.archive-profile-clear-all'
    );

  if (profileClearAll && !profileClearAll.disabled) {
    openArchiveClearDialog('profile');
    return;
  }

  const distilleryClearAll =
    e.target.closest(
      '.archive-distilleries-clear-all'
    );

  if (distilleryClearAll && !distilleryClearAll.disabled) {
    openArchiveClearDialog(
      'distilleries'
    );
    return;
  }

  const profileRowClear =
    e.target.closest(
      '.archive-profile-row-clear'
    );

  if (profileRowClear && !profileRowClear.disabled) {
    const group =
      profileRowClear.closest(
        '.archive-profile-group'
      );

    group
      ?.querySelectorAll(
        '.archive-chip.active'
      )
      .forEach(chip =>
        chip.classList.remove('active')
      );

    syncProfileRowClearActions();
    saveArchiveProfile();
    return;
  }

  const categoryClear =
    e.target.closest(
      '.archive-selected-category-clear'
    );

  if (categoryClear) {
    const key = categoryClear.dataset.key;

    if (key in selectedDistilleries) {
      selectedDistilleries[key] = [];
      renderSelectedDistilleryTags();
      saveArchiveProfile();

      const search =
        document.getElementById(
          'archiveDistillerySearch'
        );

      if (
        key === getCurrentDistilleryKey() &&
        search
      ) {
        renderDistillerySuggestions(
          search.value
        );
      }
    }
    return;
  }

  if (e.target.classList.contains('archive-chip')) {

    e.target.classList.toggle('active');

    syncProfileRowClearActions();
    saveArchiveProfile();

    return;
  }

  const tab =
    e.target.closest(
      '.archive-distillery-tab'
    );

  if (tab) {

    document
  .querySelectorAll(
    '.archive-distillery-tab'
  )
  .forEach(x => {

    x.classList.remove('active');

    const img =
      x.querySelector(
        '.archive-tab-icon'
      );

    if (!img) {
      return;
    }

    if (
      x.dataset.type === 'Malt'
    ) {

      img.src =
        'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/post_still_grey.svg?v=1780866664';

    } else {

      img.src =
        'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/column_still_grey.svg?v=1780866663';

    }

  });

tab.classList.add('active');

const activeImg =
  tab.querySelector(
    '.archive-tab-icon'
  );

if (activeImg) {

  if (
    tab.dataset.type === 'Malt'
  ) {

    activeImg.src =
      'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/post_still_gold.svg?v=1780866664';

  } else {

    activeImg.src =
      'https://cdn.shopify.com/s/files/1/0743/6582/9294/files/column_still_gold.svg?v=1780866664';

  }

}

    activeDistilleryType =
      tab.dataset.type;

    activeDistilleryStatus =
      tab.dataset.status;

    renderDistillerySections();

    return;
  }

  const distillery =
  e.target.closest(
    '.archive-distillery-option'
  );

if (distillery) {

  const name =
    distillery.dataset.distillery;

  const currentKey =
    getCurrentDistilleryKey();

  if (!selectedDistilleries[currentKey]) {
    selectedDistilleries[currentKey] = [];
  }

  if (
    !selectedDistilleries[currentKey]
      .includes(name)
  ) {

    selectedDistilleries[currentKey]
      .push(name);

  }

renderSelectedDistilleryTags();

saveArchiveProfile();

const search =
  document.getElementById(
    'archiveDistillerySearch'
  );

if (search) {

  renderDistillerySuggestions(
    search.value
  );

  search.focus();

}

return;
}

const remove =
  e.target.closest(
    '.archive-distillery-remove'
  );

if (remove) {

  const currentKey =
    remove.dataset.key ||
    getCurrentDistilleryKey();

  selectedDistilleries[currentKey] =
    (
      selectedDistilleries[currentKey] || []
    ).filter(
      x => x !== remove.dataset.name
    );

  renderSelectedDistilleryTags();

  saveArchiveProfile();

  return;
}

});

document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape') {
    return;
  }

  const openDetails =
    Array.from(
      document.querySelectorAll(
        '.archive-selected-more[open]'
      )
    );

  openDetails.forEach(details =>
    details.removeAttribute('open')
  );

  openDetails.at(-1)
    ?.querySelector('summary')
    ?.focus();

  const info =
    document.querySelector(
      '.archive-selected-info.is-hovered, .archive-selected-info.is-pinned'
    );

  if (info) {
    closeSelectedInfoPopover(info, true);
  }
});


document
  .getElementById('archiveAccountLink')
  ?.addEventListener('click', function (e) {

    e.preventDefault();

    document
      .querySelector('a[href*="/account"], .header__icon--account')
      ?.click();

  });
  
async function saveCustomerProfile(button) {

      if (!button || button.dataset.saving === 'true') {
        return;
      }

      if (profileCloudLoadFailed) {
        showArchiveToast({
          type: 'error',
          title: 'Profile Couldn’t Be Loaded',
          message: 'Please refresh the page before saving your Archive Profile.'
        });
        return;
      }

      if (!profileHasUnsavedChanges()) {
        syncProfileDirtyState();
        return;
      }

      setArchiveSaveButtonLoading(button, true);

      try {

      const watchlistController =
        window.ArchiveWatchlist;

      if (!watchlistController) {
        showArchiveToast(
          {
            type: 'error',
            title: 'Profile Couldn’t Be Saved',
            message: 'Unable to initialize your Archive Watchlist. Please try again.'
          }
        );
        return;
      }

      await watchlistController.ready;

      if (watchlistController.status !== 'ready') {
        showArchiveToast(
          {
            type: 'error',
            title: 'Profile Couldn’t Be Saved',
            message: 'Unable to safely load your Archive Watchlist. Please try again.'
          }
        );
        return;
      }

      saveArchiveProfile();

      let profileData =
        JSON.parse(
          localStorage.getItem(
            archiveProfileStorageKey
          ) || '{}'
        );

      localStorage.setItem(
        archiveProfileStorageKey,
        JSON.stringify(
          profileData
        )
      );

      if (
        window.archiveCustomerId
      ) {

        const personaPatch = {
          archiveProfile: profileData.archiveProfile,
          currentPersona: profileData.currentPersona
        };

        if (profileData.originalPersona) {
          personaPatch.originalPersona = profileData.originalPersona;
        }

        const savedProfile =
          await saveProfileToCloud(
            window.archiveCustomerId,
            personaPatch
          );

        if (savedProfile) {

          profileData = savedProfile;
          localStorage.setItem(
            archiveProfileStorageKey,
            JSON.stringify(profileData)
          );

          setLastSavedProfileBaseline(profileData);

		  showArchiveToast(
			{
              type: 'success',
              title: 'Archive Profile Saved',
              message: 'Your preferences are now preserved across future visits and devices.'
            }
		  );

          showBackToRewardsButton();

		} else {

		  showArchiveToast(
			{
              type: 'error',
              title: 'Profile Couldn’t Be Saved',
              message: 'Please try again.'
            }
		  );

		}

      }

      } catch (error) {
        console.error('Unable to save Archive Profile', error);
        showArchiveToast({
          type: 'error',
          title: 'Profile Couldn’t Be Saved',
          message: 'Please try again.'
        });
      } finally {
        setArchiveSaveButtonLoading(button, false);
      }

}

document
  .getElementById('archiveSaveCustomerProfile')
  ?.addEventListener('click', function () {
    saveCustomerProfile(this);
  });

async function resumePendingProfileSave() {
  const pendingAction = archiveOwnershipResolution.pendingAction;
  if (!pendingAction || archiveOwnershipResolution.decision !== 'keep') return;

  if (profileCloudLoadFailed) return;

  if (profileCloudHadExistingProfile) {
    window.ArchiveOwnership?.consumePendingAction();
    return;
  }

  const button = document.getElementById('archiveSaveCustomerProfile');
  if (!button) return;

  window.ArchiveOwnership?.consumePendingAction();
  await saveCustomerProfile(button);
}

await resumePendingProfileSave();

})();
